<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12i8lDm/tc-custom/9781459237360.jpg?1705007636334" alt="This image is the cover for the book Second Sister, Heartskeep"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Second Sister, Heartskeep
      </h1>
      <p class="bookDescription body article font2">
        <b>A woman comes home to claim her inheritance and her reunion with her first love puts them both in danger in this romantic suspense. </b><br/><br/>THE QUIET TWIN<br/><br/>Heartskeep heiress Leigh Thomas hated the label. But the one night she’d dared to rebel had ended in disaster. When sexy and forbidden bad boy Gavin Jarret had rescued her from a dangerous situation, she’d seduced him with all the secret passion in her wild heart—and had become his alibi for murder.<br/><br/>Coming home to Heartskeep seven years later brought Leigh face-to-face with the past—with Gavin as attorney for the estate. He was more off-limits than ever, but the heat in his deep gray eyes said Gavin still remembered that night. Now their professional relationship stirred a killer at large—one whose desperation to keep them apart would make their “strictly business” vows impossible to keep. . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dani Sinclair
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?25e2937c